import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import type { StaffMembershipType } from '../types';
import { loadPartnerRoleTemplates } from './core';

/**
 * The loading of the entire set of partner role templates is delayed until needed.
 */
export const load = (
  /** Provided by fluxible. */
  actionContext: ActionContext,
  /**
   * Id and type of entity from which to load memberships.
   */
  {
    partnerId,
    type,
    // API DI.
    _load = loadPartnerRoleTemplates,
  }: {
    partnerId: string | number;
    type: keyof typeof StaffMembershipType;
    _load?(actionContext: ActionContext, args: $TSFixMe): Q.Promise<void>;
  }
): Q.Promise<void> => {
  // Assumed called one time on page load. Do not re-call if data is initialized.
  const initializing = actionContext.getStore('StaffManagementStoreV2').partnerRoleTemplates('initializing');
  if (initializing) {
    return actionContext.executeAction(_load, { partnerId, type }).catch(() => {
      // The UI calling this will observe the error stored in state and degrade gracefully.
      // Any other logging is assumed done at a lower level.
    });
  } else {
    return Q.resolve();
  }
};
